import React, { useState, useEffect } from "react";
import { mathMlToLatexEquation } from "../../../utils/TutorConstants";
import "../../../styles/Latex.css?__remix_sideEffect__";
const LatexRender = ({ string }) => {
  const [Latex, setLatex] = useState(null);
  useEffect(() => {
    const loadLatex = async () => {
      if (!string) {
        return;
      }
      const LatexModule = await import("react-latex-next");
      setLatex(() => LatexModule.default);
    };
    loadLatex();
  }, [string]);
  if (!Latex || !string) {
    return null;
  }
  return <Latex>{mathMlToLatexEquation(string)}</Latex>;
};

export default LatexRender;